import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  auth: {
    username: 'api-user',
    password: 'vngjpM#%8JX6NRhe26Z8m?udC^73$3@6',
  },
});

export default instance;
